import { safetyGet } from 'Src/util/tool'

export const getConf = (prefix, path, defaultValue) => safetyGet(window, `GLOBAL_CONF.${prefix}.${path}`, defaultValue)

const register = (name, param) => {
  window[name] = param
}

export const registerFactory = obj => {
  Object.keys(obj).forEach(e => register(e, obj[e]))
}
